import { render, staticRenderFns } from "./bugDetermine.vue?vue&type=template&id=12275ec2&scoped=true&"
import script from "./bugDetermine.vue?vue&type=script&lang=js&"
export * from "./bugDetermine.vue?vue&type=script&lang=js&"
import style0 from "./bugDetermine.vue?vue&type=style&index=0&id=12275ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12275ec2",
  null
  
)

export default component.exports